//export const API_URL = "http://sllserp.sllssrq.com";
export const API_URL = "https://i.tysoft.com";
//export const API_URL = "http://101.37.150.30:8081";
// export const API_URL = "http://localhost:8081";
// export const API_URL = "http://10.136.64.213:8081";  
// export const API_URL = "http://10.136.64.213:8081";
